exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vux-masker-box{position:relative}.vux-masker{position:absolute;top:0;left:0;bottom:0;right:0;border-radius:inherit}.vux-masker-fullscreen{position:fixed;z-index:10001}", ""]);

// exports
